document.addEventListener("DOMContentLoaded", function () {
	const navMainContainer = document.getElementById("navMainContainer");
	const burgerBtnOpen = document.getElementById("burgerBtnOpen");
	const burgerBtnClose = document.getElementById("burgerBtnClose");

	function openMenu() {
		navMainContainer.classList.add("open");
		document.body.classList.add("nav-open");
		burgerBtnOpen.setAttribute("aria-expanded", "true");
	}

	function closeMenu() {
		navMainContainer.classList.remove("open");
		document.body.classList.remove("nav-open");
		burgerBtnOpen.setAttribute("aria-expanded", "false");
	}

	if (burgerBtnOpen) {
		burgerBtnOpen.addEventListener("click", openMenu);
	}
	if (burgerBtnClose) {
		burgerBtnClose.addEventListener("click", closeMenu);
	}

	document.addEventListener("keydown", (e) => {
		if (e.key === "Escape") {
			closeMenu();
		}
	});
});
